<template>
  <div class="w3-center">
    <div class="Is-there-a-secret-to">
      <p>{{ $ml.get('secretMonitor') }}</p>
    </div>
    <!--
    <div class="Rectangle-3 w3-btn">
      <span class="capitalize">{{ $ml.get('tellMeMore') }}</span>
    </div>
    -->
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
